import { Component, Fragment, h, Prop } from '@stencil/core';
import { StepItem, StepsError, Translations } from '../../../redux/types';
import { Unsubscribe } from '@stencil/redux';
import { stepKey, trans } from '../../../utils/trans';
import { store } from '../../../redux/store';
import { RootState } from '../../../redux/reducers';

@Component({
  tag: 'rentware-checkout-nav-bar',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCheckoutNavBar {
  @Prop() currentIndex: number;
  @Prop() steps: StepItem[];
  @Prop() currentStep: StepItem;
  @Prop() isWaiting: boolean;
  @Prop() onStepClick: () => any;
  @Prop() onNextBtnClick: () => void;
  @Prop() onCloseCheckout: () => any;
  @Prop() errors: StepsError[];
  @Prop() handleGoToFirstErrorClick;
  @Prop() onValidateClick: () => void;
  @Prop() onGoToStep: (id: string) => void;

  @Prop({ mutable: true }) translations: Translations;
  @Prop({ mutable: true }) locale: string;
  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        translations: state.system.translations,
        locale: state.app.locale,
      };
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  get currentStepName() {
    return (this.currentStep && trans(stepKey(this.currentStep.id), this.locale, this.translations)) || '';
  }

  goToPreviousStep = () => {
    if (!this.isWaiting) {
      const previousStepId = this.steps[this.currentIndex - 1]?.id;
      this.onGoToStep(previousStepId);
    }
  };

  goToNextStep = () => {
    if (!this.isWaiting) {
      this.onNextBtnClick();
    }
  };

  openBreadCrumbs = () => {
    if (!this.isWaiting) {
      this.onStepClick();
    }
  };

  get currentStepErrors(): StepsError[] {
    return this.errors?.filter(error => error.stepId === this.currentStep.id);
  }

  render() {
    if (!this.steps) {
      return null;
    }

    const showLeftArrow = this.currentIndex > 1;
    const showRightArrow = this.currentIndex < this.steps.length - 1;

    return (
      <Fragment>
        <div class="Bar">
          {(this.currentStep && (
            <div class="Left">
              <span class="Ellipsis">{this.currentStepName}</span>
            </div>
          )) || <div class="Left">{trans('checkout.successTitle', this.locale, this.translations)}</div>}

          {this.currentStep && (
            <div class="Center">
              {showLeftArrow && (
                <div onClick={this.goToPreviousStep} class={{ CenterField: true, LeftField: true, CenterFieldWaiting: this.isWaiting }}>
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 4L6.5 10L12.5 16" stroke="#46435B" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              )}

              <div onClick={this.openBreadCrumbs} class={{ CenterField: true, CenterFieldWaiting: this.isWaiting }}>
                <span class="HideOnMobile">
                  {trans('checkout.step', this.locale, this.translations)}
                  &nbsp;
                </span>

                <span>
                  {this.currentIndex}/{this.steps.length - 1}
                </span>
              </div>

              {showRightArrow && (
                <div onClick={this.goToNextStep} class={{ CenterField: true, RightField: true, CenterFieldWaiting: this.isWaiting }}>
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 4L14.5 10L8.5 16" stroke="#46435B" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              )}
            </div>
          )}

          <div class="Right">
            <rentware-close-button onClick={this.onCloseCheckout} />
          </div>
        </div>

        {this.currentStepErrors?.length > 0 && (
          <rentware-checkout-error
            currentStep={this.currentStep}
            errors={this.errors}
            handleGoToFirstErrorClick={this.handleGoToFirstErrorClick}
            locale={this.locale}
            translations={this.translations}
          />
        )}
      </Fragment>
    );
  }
}
